import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Box, Typography, useTheme } from "@mui/material";
import React, { FC } from "react";
import { ContainedButton } from "components/ContainedButton";
import { OutlinedButton } from "components/OutlinedButton";
import { DocumentFile } from "../../../types";
import { SortableItem } from "../../SortableItem";

type Props = {
  documentFile: DocumentFile,
  isMobile?: boolean,
  actionLabel?: string,
  actionIcon?: IconProp,
  actionVariant?: 'contained' | 'outlined',
  onAction?: () => void,
}

export const DocumentFileSortableItem: FC<Props> = ({
  documentFile: { _id, description, data },
  isMobile = false,
  actionLabel,
  actionIcon,
  actionVariant = 'contained',
  onAction,
}) => {
  const theme = useTheme();

  return (
    <SortableItem key={_id} id={_id} disabled={isMobile}>
      <Box>
        <Box style={{
          backgroundColor: "#f8fafb",
          height: "2rem",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid lightgray",
          justifyContent: "space-between",
          borderRadius: '4px 4px 0px 0px',
          paddingLeft: "0.5rem"
        }}
        >
          <Typography variant="body1" color="primary">{description.length > 40 ? `${description.toString().substring(0, 40 - 3)}...` : description}</Typography>
        </Box>
        <Box style={{ padding: "0.5rem", backgroundColor: "white" }}>
          {data?.filter(({ kind: fileKind }) => fileKind === "property" || fileKind === "party").map(({ kind: fileKind, kinds, address, name }) => (
            <Typography variant="body2">
              *
              {fileKind !== "property" ? (`${name}(${kinds?.join(",")})`) : (address)}
            </Typography>
          ))}
        </Box>
        {isMobile && actionLabel && actionIcon && onAction && (
          <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: theme.spacing(1) }}>
            {actionVariant === 'outlined' ? (
              <OutlinedButton
                text={actionLabel}
                ariaLabel={`${actionLabel} ${description}`}
                icon={actionIcon}
                onClick={onAction}
                customStyle={{ minHeight: 44 }}
              />
            ) : (
              <ContainedButton
                text={actionLabel}
                ariaLabel={`${actionLabel} ${description}`}
                icon={actionIcon}
                onClick={onAction}
                customStyle={{ minHeight: 44 }}
              />
            )}
          </Box>
        )}
      </Box>
    </SortableItem>
  );
};
